// MUI
import { Dialog, DialogContent, Typography, IconButton, Button, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

type DeleteLotDialogProps = {
	lotKey: string;
	open: boolean;
	lotName: string;
	content: string;
	onClose: () => void;
	removeLot: (lotKey: string) => void;
};

export default function DeleteLotDialog(props: Readonly<DeleteLotDialogProps>) {
	const { open, onClose, content, removeLot, lotKey } = props;
	return (
		<Dialog
			open={open}
			onClose={onClose}
			PaperProps={{
				style: {
					width: "244px",
					height: "159px",
					borderRadius: "10px",
				},
			}}
		>
			<IconButton aria-label="close" onClick={onClose} classes={{ root: "!absolute !top-[4px] !right-[4px] !text-[#B3B3B3]" }}>
				<CloseIcon sx={{ fontSize: "18px" }} />
			</IconButton>
			<DialogContent>
				<Typography className="!font-sans !font-normal !text-[14.5px] text-default pb-4">{content}</Typography>

				<Stack direction={"row"} spacing={4} justifyContent="center" alignItems="center">
					<Button variant="contained" color={"secondary"} className={"w-[82px]"} onClick={onClose}>
						Cancel
					</Button>
					<Button variant="contained" color={"primary"} className={"w-[82px]"} onClick={() => removeLot(lotKey)}>
						Remove
					</Button>
				</Stack>
			</DialogContent>
		</Dialog>
	);
}
